import { render, staticRenderFns } from "./ThreeShader.vue?vue&type=template&id=4c2213b4&"
import script from "./ThreeShader.vue?vue&type=script&lang=js&"
export * from "./ThreeShader.vue?vue&type=script&lang=js&"
import style0 from "./ThreeShader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports